<script>
  import tooltip from '@leaflink/stash/directives/tooltip';
  import Icon from '@leaflink/stash/Icon.vue';

  import { hasVolumeDiscount, isParent } from '../utils';

  export default {
    name: 'DiscountTag',

    components: {
      Icon,
    },

    directives: {
      tooltip,
    },

    props: {
      campaignLabel: {
        type: String,
        default: '',
      },

      classes: {
        type: Array,
        default: () => [],
      },

      product: {
        type: Object,
        required: true,
        default: () => ({}),
      },

      small: {
        type: Boolean,
        default: false,
      },

      volumeFirst: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      /**
       * Used for rendering color and tooltip for the icon tag
       */
      discountTag() {
        const { campaignLabel, hasSaleDiscount, hasVolumeDiscount, product, volumeFirst } = this;
        const hasDealsDiscount = product.isFeaturedOnDeals && !!campaignLabel;

        if (hasVolumeDiscount(product) && volumeFirst) {
          return {
            color: 'color-orange',
            name: 'tag',
            tooltip: this.$t('shop.volumeDiscountTooltip'),
          };
        } else if (hasDealsDiscount) {
          return {
            color: 'color-teal',
            name: 'tag-star',
            tooltip: this.$t('shop.deals.featuredOnDeals', { campaignLabel: this.campaignLabel }),
          };
        } else if (hasSaleDiscount) {
          return {
            color: 'color-red',
            name: 'tag',
            tooltip: this.$t('shop.saleDiscountTooltip'),
          };
        }

        return null;
      },

      /**
       * Whether or not the product or its children have a sale price
       */
      hasSaleDiscount() {
        const { product, isParent } = this;

        return isParent(product) ? product.children.some((p) => p.salePrice) : !!product.salePrice;
      },
    },

    methods: {
      isParent,
      hasVolumeDiscount,
    },
  };
</script>

<template>
  <div v-if="discountTag" v-tooltip.top="discountTag.tooltip">
    <Icon :class="[...classes, discountTag.color]" :name="discountTag.name" :small="small" />
  </div>
</template>
